import React, { useState } from "react";
import { getLanguageSet, template } from "../Locales";
import { casing } from "./contextHelper";

const LanguageContext = React.createContext();
export default LanguageContext;

export function LanguageContextWrapper(props) {
  const [localeSet, setLocaleSet] = useState(getLanguageSet());
  const setLocaleContext = (value) => {
    const newLocalSet = getLanguageSet(value);
    setLocaleSet(newLocalSet);
  };

  return (
    <LanguageContext.Provider
      value={{
        localeSet,
        setLocaleContext,
        casing,
        template,
      }}
    >
      {props.children}
    </LanguageContext.Provider>
  );
}



// WEBPACK FOOTER //
// ../nx-components/src/ContextWrappers/LanguageContext.jsx